// @ts-nocheck
import { loadUnitsCatalog, normalizeAliasKey } from './loadUnitsCatalog';
import type { UnitsCatalog } from './types';

const UNIT_SYMBOL_REPLACEMENTS: ReadonlyArray<[RegExp, string]> = [
  [/″/g, '"'],
  [/′/g, "'"],
  [/²/g, '2'],
  [/³/g, '3'],
  [/\.(?=$|\s)/g, ''],
];

export function cleanupUnitString(raw: string): string {
  let value = raw.trim();
  for (const [pattern, replacement] of UNIT_SYMBOL_REPLACEMENTS) {
    value = value.replace(pattern, replacement);
  }
  return value.replace(/\s+/g, ' ').trim();
}

export function resolveUnitId(
  raw: string,
  catalog: UnitsCatalog = loadUnitsCatalog(),
  locale = 'en',
): string | null {
  const cleaned = cleanupUnitString(raw);
  if (cleaned.length === 0) {
    return null;
  }

  const direct = catalog.aliasIndex.get(normalizeAliasKey(cleaned));
  if (direct) {
    return direct;
  }

  const localePrefix = locale.split(/[-_]/)[0]?.toLowerCase() ?? 'en';
  const withoutPlural = cleaned.replace(/s$/i, '');
  const candidates = [
    cleaned,
    withoutPlural,
    cleaned.replace(/\./g, ''),
    cleaned.replace(/\s/g, ''),
  ];

  for (const candidate of candidates) {
    const hit = catalog.aliasIndex.get(normalizeAliasKey(candidate));
    if (hit) {
      return hit;
    }
  }

  void localePrefix;
  return null;
}

export function resolveMaterialId(
  raw: string,
  catalog: UnitsCatalog = loadUnitsCatalog(),
): string | null {
  const cleaned = cleanupUnitString(raw);
  if (cleaned.length === 0) {
    return null;
  }

  const direct = catalog.materialAliasIndex.get(normalizeAliasKey(cleaned));
  if (direct) {
    return direct;
  }

  return catalog.materialAliasIndex.get(normalizeAliasKey(cleaned.replace(/s$/i, ''))) ?? null;
}
